const data = [
	{
		ATAL: `Attnded one week FDP on “"Big Data Security and Analytics"`,
	},
	{
		ATAL: `Attended one week FDP on "Artificial Intelligence and Machine Learning for Healthcare"`,
	},
	{
		ATAL: `Attended one Week FDP on "Data Science"`,
	},
	{
		ATAL: `Attended one week FDP on "Foundations of Data Science and Machine Learning for 
		Cross-domain Applications"`,
	},
	{
		ATAL: `Attended one week FDP on "Leadership & Excellence"`,
	},
	{
		ATAL: `Attended one week FDP on “"Introduction to Quantum Computing"`,
	},
];

export default data;
